<!-- Table Desktop -->
<ng-template #actionHeader>
  <span class="sr-only">Actions</span>
</ng-template>
<ng-template #dynamicHeader let-column="column">
  <span [innerHTML]="column.name | globalTranslate | sanitize"></span>
</ng-template>
<ngx-datatable
  class="nh-table bootstrap d-none d-lg-block"
  columnMode="flex"
  rowHeight="auto"
  [headerHeight]="65"
  [footerHeight]="sectionId === 'HHSUR' || isFooterDisable ? 0 : 50"
  [limit]="limit"
  [rows]="sectionId === 'ARPDT' ? appealRows : rows"
>
  @for (head of columns; track head) {
  <ngx-datatable-column
    [cellClass]="'my-auto'"
    [name]="head.name"
    [headerTemplate]="dynamicHeader"
    [resizeable]="false"
    [flexGrow]="hasPhonenumbers ? 5 : 8"
  >
    <ng-template let-row="row" ngx-datatable-cell-template>
      @if (sectionId === 'ARPDT' && head.name === 'Relationship') {
      <div
        [innerHTML]="
          row
            | path: head.prop
            | loader: head.pipe:head.args
            | globalTranslate
            | sanitize
        "
      ></div>
      } @if (sectionId === 'ARPDT' && head.name !== 'Relationship' &&
      shouldSkipTranslation(head.name, row | path: head.prop | loader:
      head.pipe:head.args)) {
      <div
        [innerHTML]="
          row | path: head.prop | loader: head.pipe:head.args | sanitize
        "
      ></div>
      } @if (sectionId === 'ARPDT' && head.name !== 'Relationship' &&
      !shouldSkipTranslation(head.name, row | path: head.prop | loader:
      head.pipe:head.args)) {
      <div
        [innerHTML]="
          row
            | path: head.prop
            | loader: head.pipe:head.args
            | globalTranslate
            | sanitize
        "
      ></div>
      } @if (sectionId !== 'ARPDT' && shouldSkipTranslation(head.name, row |
      path: head.prop | loader: head.pipe:head.args)) {
      <div
        [innerHTML]="
          row | path: head.prop | loader: head.pipe:head.args | sanitize
        "
      ></div>
      } @if (sectionId !== 'ARPDT' && !shouldSkipTranslation(head.name, row |
      path: head.prop | loader: head.pipe:head.args)) {
      <div
        [innerHTML]="
          row
            | path: head.prop
            | loader: head.pipe:head.args
            | globalTranslate
            | sanitize
        "
      ></div>
      }
    </ng-template>
  </ngx-datatable-column>
  } @if (sectionId !== 'HHSUR' && sectionId !== 'ARPDT') {
  <ngx-datatable-column
    [flexGrow]="12"
    class="me-3 pr-md-1 py-sm-1"
    [headerTemplate]="actionHeader"
    name=""
  >
    <ng-template
      ngx-datatable-cell-template
      let-row="row"
      let-rowIndex="rowIndex"
    >
      <div class="text-center">
        <button
          class="btn btn-sm btn-secondary edit-{{ rowIndex }}"
          [disabled]="
            sectionId === 'HHTJF' &&
            enableEditReview &&
            row?.data?.taxFilingStatus !== 'Filer' &&
              row?.data?.taxFilingStatus !== null
          "
          (click)="onEdit(row)"
        >
          @if (!isEbmsDriverFlow) {
          <span>{{ "SUMMARY_EDIT" | globalTranslate }}</span>
          } @if (isEbmsDriverFlow && row.reviewed !== true) {
          <span>{{ "REVIEW" | globalTranslate }}</span>
          } @if (isEbmsDriverFlow && row.reviewed === true) {
          <span>{{ "APPEAL_SUMMARY_EDIT" | globalTranslate }}</span>
          }
        </button>
        @if (sectionId === 'HHIND' && row.data.headOfHousehold) {
        <div>
          <nh-popover
            [content]="headOfHouseHoldContent | globalTranslate"
          ></nh-popover>
        </div>
        } @if (canDelete(row)) {
        <div class="ps-2 pt-1 hover-red">
          <button
            class="btn btn-link btn-lg hover-red delete-{{ rowIndex }}"
            [disabled]="
              sectionId === 'HHTJF' &&
              enableEditReview &&
              row?.data?.taxFilingStatus !== null &&
                (row?.data?.taxFilingStatus === 'In Household Dependent' ||
                  row?.data?.taxFilingStatus === 'Joint Filer' ||
                  row?.data?.taxFilingStatus === 'Out of Household Dependent')
            "
            (click)="onDelete(row)"
          >
            <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
            <nh-remove-svg></nh-remove-svg>
          </button>
        </div>
        } @if (sectionId === 'HHTJF' && row.data.taxFilingStatus !== 'Filer') {
        <nh-popover
          [content]="
            taxPopUpOne + name[rowIndex] + taxPopUpTwo | globalTranslate
          "
        ></nh-popover>
        }
      </div>
    </ng-template>
  </ngx-datatable-column>
  } @if (sectionId !== 'HHSUR' && sectionId !== 'ARPDT' && isEbmsDriverFlow) {
  <ngx-datatable-column
    [flexGrow]="12"
    class="me-3 pr-md-1 py-sm-1"
    name="{{ 'Review Complete?' | globalTranslate }}"
  >
    <ng-template
      ngx-datatable-cell-template
      let-row="row"
      let-rowIndex="rowIndex"
    >
      <div class="text-center">
        @if (row.reviewed === false) {
        <span class="text-danger"
          ><i
            role="img"
            class="fa fa-times fa-2x"
            [attr.aria-label]="'REVIEW_STATUS_NOT_COMPLETED' | globalTranslate"
          ></i
        ></span>
        } @if (row.reviewed === true) {
        <span class="text-success"
          ><i
            role="img"
            class="fa fa-check fa-2x"
            [attr.aria-label]="'REVIEW_STATUS_COMPLETED' | globalTranslate"
          ></i
        ></span>
        }
      </div>
    </ng-template>
  </ngx-datatable-column>
  } @if (sectionId === 'ARPDT') {
  <ngx-datatable-column
    [flexGrow]="12"
    class="me-3 pr-md-1 py-sm-1"
    name="{{ appealActionHeader | globalTranslate }}"
  >
    <ng-template
      ngx-datatable-cell-template
      let-row="row"
      let-rowIndex="rowIndex"
    >
      @if (!row.data.disableEdit) {
      <div class="pt-1 hover-red">
        <button
          class="btn btn-link btn-lg hover-red edit-{{ rowIndex }}"
          (click)="onEdit(row)"
        >
          <span class="pe-2">{{
            "APPEAL_SUMMARY_EDIT" | globalTranslate
          }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 2.5 19.5 19.49">
            <g id="_icons_create-outline" data-name=" icons create-outline">
              <path
                id="Combined_Shape-287"
                data-name="Combined Shape-287"
                class="cls-1"
                d="M2.63,19.49A2.62,2.62,0,0,1,0,16.91V5.62A2.63,2.63,0,0,1,2.58,3h7.9a.75.75,0,0,1,.75.75.74.74,0,0,1-.74.75H2.63A1.12,1.12,0,0,0,1.5,5.6V16.87A1.12,1.12,0,0,0,2.61,18H13.88A1.12,1.12,0,0,0,15,16.89V8.24a.76.76,0,0,1,.74-.76.75.75,0,0,1,.76.75v8.64a2.62,2.62,0,0,1-2.59,2.62Zm4.92-7.55a.17.17,0,0,1,0-.18l.39-1.17A.42.42,0,0,1,8,10.41L16.47,2a.43.43,0,0,1,.6,0h0l.47.47a.42.42,0,0,1,0,.59L9.09,11.49a.5.5,0,0,1-.19.1L7.74,12H7.68a.21.21,0,0,1-.13-.05ZM18.17,1.85l-.53-.53a.39.39,0,0,1,0-.53h0l.58-.58a.76.76,0,0,1,1.07,0,.75.75,0,0,1,0,1.06l-.56.57a.4.4,0,0,1-.54,0h0Z"
              />
            </g>
          </svg>
        </button>
      </div>
      } @if (canDelete(row)) {
      <div class="pt-1 hover-red">
        <button
          class="btn btn-link btn-lg hover-red delete-{{ rowIndex }}"
          (click)="onDeleteAplRow(row)"
        >
          <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
          <nh-remove-svg></nh-remove-svg>
        </button>
      </div>
      }
    </ng-template>
  </ngx-datatable-column>
  } @if (sectionId === 'HHSUR') {
  <ngx-datatable-column
    [flexGrow]="12"
    name="Are the people below still living in your household?"
    headerClass="text-right"
  >
    <ng-template
      ngx-datatable-cell-template
      let-row="row"
      let-rowIndex="rowIndex"
    >
      @if (rowIndex > 0) {
      <span class="summary-ctas">
        <select
          class="form-select"
          [(ngModel)]="options[rowIndex]"
          (change)="onChange()"
        >
          <option></option>
          @for (item of items; track item) {
          <option>{{ item.value }}</option>
          }
        </select>
      </span>
      }
    </ng-template>
  </ngx-datatable-column>
  }
</ngx-datatable>

<!-- Table Mobile -->
<div class="nh-table-mobile mt-3 pt-2 d-lg-none" role="table">
  @if (sectionId !== 'ARPDT') {
  <div>
    @for (row of rows; track row; let i = $index) {
    <div class="table-row mb-3 pb-3" role="row">
      @for (head of columns; track head) {
      <div role="cell">
        <div
          class="mobile-table-header"
          role="rowheader"
          [innerHtml]="head.name | globalTranslate | sanitize"
        ></div>
        <hr />
        @if (shouldSkipTranslation(head.name, row | path: head.prop | loader:
        head.pipe : head.args)) {
        <div
          class="mobile-table-data"
          [innerHTML]="
            row | path: head.prop | loader: head.pipe:head.args | sanitize
          "
        ></div>
        } @if (!shouldSkipTranslation(head.name, row | path: head.prop | loader:
        head.pipe : head.args)) {
        <div
          class="mobile-table-data"
          [innerHTML]="
            row
              | path: head.prop
              | loader: head.pipe:head.args
              | globalTranslate
              | sanitize
          "
        ></div>
        }
        <br />
      </div>
      }
      <button
        class="btn btn-secondary btn-sm edit-{{ i }}"
        [disabled]="
          sectionId === 'HHTJF' &&
          enableEditReview &&
          row?.data?.taxFilingStatus !== 'Filer' &&
            row?.data?.taxFilingStatus !== null
        "
        [ngClass]="
          sectionId === 'HHIND' && row.data.headOfHousehold ? 'w-90' : 'w-100'
        "
        (click)="onEdit(row)"
        #onFocus
      >
        @if (!isEbmsDriverFlow) {
        <span>{{ "SUMMARY_EDIT" | globalTranslate }}</span>
        } @if (isEbmsDriverFlow && row.reviewed !== true) {
        <span>{{ "REVIEW" | globalTranslate }}</span>
        } @if (isEbmsDriverFlow && row.reviewed === true) {
        <span>{{ "APPEAL_SUMMARY_EDIT" | globalTranslate }}</span>
        }
      </button>
      @if (sectionId === 'HHIND' && row.data.headOfHousehold) {
      <nh-popover
        class="ps-2"
        [content]="headOfHouseHoldContent | globalTranslate"
      ></nh-popover>
      } @if (canDelete(row)) {
      <div class="pt-1 hover-red text-center">
        <button
          class="btn btn-link btn-lg hover-red delete-{{ i }}"
          [disabled]="
            sectionId === 'HHTJF' &&
            enableEditReview &&
            row?.data?.taxFilingStatus !== null
          "
          (click)="onDelete(row)"
        >
          <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
          <nh-remove-svg></nh-remove-svg>
        </button>
      </div>
      } @if (sectionId !== 'HHSUR' && sectionId !== 'ARPDT' && isEbmsDriverFlow)
      {
      <div class="mobile-table-header review" role="rowheader">
        {{ "Review Complete?" | globalTranslate }}
        <hr />
        <div>
          @if (row.reviewed === false) {
          <span class="text-danger"
            ><i
              role="img"
              class="fa fa-times fa-2x"
              [attr.aria-label]="
                'REVIEW_STATUS_NOT_COMPLETED' | globalTranslate
              "
            ></i
          ></span>
          } @if (row.reviewed === true) {
          <span class="text-success"
            ><i
              role="img"
              class="fa fa-check fa-2x"
              [attr.aria-label]="'REVIEW_STATUS_COMPLETED' | globalTranslate"
            ></i
          ></span>
          }
        </div>
      </div>
      } @if (sectionId === 'HHTJF' && row.data.taxFilingStatus !== 'Filer') {
      <nh-popover
        [content]="taxPopUpOne + name[i] + taxPopUpTwo | globalTranslate"
      ></nh-popover>
      }
    </div>
    }
  </div>
  } @if (sectionId === 'ARPDT') {
  <div>
    @for (row of appealRows; track row; let i = $index) {
    <div class="table-row mb-3 pb-3" role="row">
      @for (head of columns; track head) {
      <div role="cell">
        <div
          class="mobile-table-header"
          [innerHtml]="head.name | globalTranslate | sanitize"
          role="rowheader"
        ></div>
        <hr />
        @if (shouldSkipTranslation(head.name, row | path: head.prop | loader:
        head.pipe : head.args)) {
        <div
          class="mobile-table-data"
          [innerHTML]="
            row | path: head.prop | loader: head.pipe:head.args | sanitize
          "
        ></div>
        } @if (!shouldSkipTranslation(head.name, row | path: head.prop | loader:
        head.pipe : head.args)) {
        <div
          class="mobile-table-data"
          [innerHTML]="
            row
              | path: head.prop
              | loader: head.pipe:head.args
              | globalTranslate
              | sanitize
          "
        ></div>
        }
        <br />
      </div>
      }
      <div class="mobile-table-header" role="rowheader">
        {{ appealActionHeader | globalTranslate }}
      </div>
      <hr />
      @if (!row.data.disableEdit) {
      <div class="pt-1 hover-red text-center">
        <button
          class="btn btn-link btn-lg hover-red edit-{{ i }}"
          (click)="onEdit(row)"
        >
          <span class="pe-2">{{
            "APPEAL_SUMMARY_EDIT" | globalTranslate
          }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 2.5 19.5 19.49">
            <g id="_icons_create-outline" data-name=" icons create-outline">
              <path
                id="Combined_Shape-287"
                data-name="Combined Shape-287"
                class="cls-1"
                d="M2.63,19.49A2.62,2.62,0,0,1,0,16.91V5.62A2.63,2.63,0,0,1,2.58,3h7.9a.75.75,0,0,1,.75.75.74.74,0,0,1-.74.75H2.63A1.12,1.12,0,0,0,1.5,5.6V16.87A1.12,1.12,0,0,0,2.61,18H13.88A1.12,1.12,0,0,0,15,16.89V8.24a.76.76,0,0,1,.74-.76.75.75,0,0,1,.76.75v8.64a2.62,2.62,0,0,1-2.59,2.62Zm4.92-7.55a.17.17,0,0,1,0-.18l.39-1.17A.42.42,0,0,1,8,10.41L16.47,2a.43.43,0,0,1,.6,0h0l.47.47a.42.42,0,0,1,0,.59L9.09,11.49a.5.5,0,0,1-.19.1L7.74,12H7.68a.21.21,0,0,1-.13-.05ZM18.17,1.85l-.53-.53a.39.39,0,0,1,0-.53h0l.58-.58a.76.76,0,0,1,1.07,0,.75.75,0,0,1,0,1.06l-.56.57a.4.4,0,0,1-.54,0h0Z"
              />
            </g>
          </svg>
        </button>
      </div>
      } @if (canDelete(row)) {
      <div class="pt-1 hover-red text-center">
        <button
          class="btn btn-link btn-lg hover-red delete-{{ i }}"
          (click)="onDeleteAplRow(row)"
        >
          <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
          <nh-remove-svg></nh-remove-svg>
        </button>
      </div>
      }
    </div>
    }
  </div>
  }
</div>